import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const a = () => /* @__PURE__ */ l.jsxs("svg", { viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M28 .004C12.538.004.004 12.54.004 28 .004 43.462 12.538 55.996 28 55.996S55.995 43.462 55.995 28 43.461.004 28 .004m0 52.68a24.684 24.684 0 1 1 0-49.368 24.684 24.684 0 0 1 0 49.367",
      fill: "#FCA311"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M28 3.317a24.684 24.684 0 1 0 0 49.369 24.684 24.684 0 0 0 0-49.37M17.004 16.41h11.104c7.402 0 11.877 3.8 11.877 10.079 0 2.365-.658 4.37-1.854 5.958l-2.955-2.78a6.7 6.7 0 0 0 .741-3.178c0-4.13-2.725-6.485-7.931-6.485H21.07v8.433l-4.067 4.326zM37.61 39.59 28 29.98l-9.611 9.61h-4.752l13.035-13.594a1.88 1.88 0 0 1 2.656 0L42.363 39.59z",
      fill: "#293963"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M26.672 25.996 13.637 39.59h4.752l9.61-9.61 9.612 9.61h4.752L29.328 25.996a1.876 1.876 0 0 0-2.656 0",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M21.071 20.004h6.915c5.206 0 7.931 2.355 7.931 6.485a6.74 6.74 0 0 1-.741 3.178l2.955 2.78c1.196-1.589 1.854-3.593 1.854-5.958 0-6.279-4.475-10.079-11.877-10.079H17.004v16.353l4.067-4.326z",
      fill: "#fff"
    }
  )
] });
export {
  a as R
};
